import React from 'react';

export function Sjalfsafgreidsla() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="112"
      viewBox="0 0 112 112"
    >
      <g
        id="Ársskýrsla/icon/Sjálfsafgreiðsla"
        fill="none"
        fillRule="evenodd"
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <g id="desktop-monitor-approve" transform="translate(27 21)">
          <circle id="Oval" cx="51.5" cy="18.5" r="18"></circle>
          <path
            id="Path"
            d="M59.522 13.265l-8.715 11.622a2.253 2.253 0 01-3.393.24l-4.5-4.5"
          ></path>
          <path id="Path" d="M12.5 48.5L63.5 48.5"></path>
          <path
            id="Shape"
            d="M63.5 39.5v15a3 3 0 01-3 3H12.625M.5 27V15.5a3 3 0 013-3h24"
          ></path>
          <path
            id="Path"
            d="M23 69.5a20.937 20.937 0 004.5-12M41 69.5a20.937 20.937 0 01-4.5-12"
          ></path>
          <path id="Path" d="M18.5 69.5L45.5 69.5"></path>
        </g>
        <g id="smart-house-phone-lock-1" transform="translate(15 48)">
          <rect
            id="Rectangle"
            width="24"
            height="42"
            x="0.5"
            y="0.5"
            rx="3"
          ></rect>
          <path id="Path" d="M0.5 6.5L24.5 6.5"></path>
          <path id="Path" d="M0.5 36.5L24.5 36.5"></path>
        </g>
      </g>
    </svg>
  );
}
